import React, { useState, useEffect, useRef } from 'react';

function App() {
  const [time, setTime] = useState('');
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [isSearchHovered, setIsSearchHovered] = useState(false);
  const [searchHistory, setSearchHistory] = useState([]);
  const [showEngineSelector, setShowEngineSelector] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [showWallpaperModal, setShowWallpaperModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showAddAppModal, setShowAddAppModal] = useState(false);
  const [showFolderSelector, setShowFolderSelector] = useState(false);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [currentWallpaper, setCurrentWallpaper] = useState('/wallpaper/Default1.jpg');
  const [selectedWallpaper, setSelectedWallpaper] = useState('/wallpaper/Default1.jpg');
  const [showAppGrid, setShowAppGrid] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const [folders, setFolders] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [currentFolderView, setCurrentFolderView] = useState(null);
  const [newAppData, setNewAppData] = useState({
    name: '',
    url: '',
    icon: '',
    folder_id: null
  });
  // 右键菜单状态
  const [contextMenu, setContextMenu] = useState({
    show: false,
    x: 0,
    y: 0,
    type: '', // 'app' 或 'folder'
    item: null // 当前右键点击的项目
  });
  // 编辑模态框状态
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const appGridRef = useRef(null);
  const searchInputRef = useRef(null);
  const loginModalRef = useRef(null);
  const addAppModalRef = useRef(null);
  const folderSelectorRef = useRef(null);
  const [currentEngine, setCurrentEngine] = useState({
    name: '百度',
    icon: '/search-ico/baidu.ico',
    searchUrl: 'https://www.baidu.com/s?wd='
  });
  
  const searchEngines = [
    {
      name: '百度',
      icon: '/search-ico/baidu.ico',
      searchUrl: 'https://www.baidu.com/s?wd='
    },
    {
      name: '谷歌',
      icon: '/search-ico/google.ico',
      searchUrl: 'https://www.google.com/search?q='
    },
    {
      name: '必应',
      icon: '/search-ico/bing.ico',
      searchUrl: 'https://www.bing.com/search?q='
    },
    {
      name: '搜狗',
      icon: '/search-ico/sogou.ico',
      searchUrl: 'https://www.sogou.com/web?query='
    },
    {
      name: '小红书',
      icon: '/search-ico/xiaohongshu.ico',
      searchUrl: 'https://www.xiaohongshu.com/search_result?keyword='
    }
  ];
  
  // 设置菜单选项
  const settingsOptions = [
    { 
      icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>, 
      text: '壁纸设置' 
    },
    { 
      icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
            </svg>, 
      text: '支持我们' 
    },
    { 
      icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>, 
      text: '关于我们' 
    },
    { 
      icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5" />
            </svg>, 
      text: '浏览器插件' 
    }
  ];
  
  // 壁纸列表
  const wallpapers = [
    { id: 'default1', name: '默认壁纸1', path: '/wallpaper/Default1.jpg' },
    { id: 'default2', name: '默认壁纸2', path: '/wallpaper/Default2.jpg' },
    { id: 'badlandsbday', name: '恶地国家公园生日', path: 'https://cn.bing.com/th?id=OHR.BadlandsBday_EN-AU10299777329_1920x1080.jpg' },
    { id: 'bigwindday', name: '大风日', path: 'https://cn.bing.com/th?id=OHR.BigWindDay_ZH-CN1837859776_1920x1080.jpg' },
    { id: 'bojoriver', name: '博霍河', path: 'https://cn.bing.com/th?id=OHR.BojoRiver_ZH-CN5454106636_1920x1080.jpg' },
    { id: 'grandcanyonwinter', name: '大峡谷冬景', path: 'https://cn.bing.com/th?id=OHR.GrandCanyonWinter_ZH-CN2640803517_1920x1080.jpg' },
    { id: 'mayottecoral', name: '马约特珊瑚礁', path: 'https://cn.bing.com/th?id=OHR.MayotteCoral_ZH-CN8106288026_1920x1080.jpg' },
    { id: 'bubblelake', name: '气泡湖', path: 'https://cn.bing.com/th?id=OHR.BubbleLake_ZH-CN7146244555_1920x1080.jpg' },
    { id: 'maldivesheart', name: '马尔代夫之心', path: 'https://cn.bing.com/th?id=OHR.MaldivesHeart_ZH-CN0032539727_1920x1080.jpg' },
    { id: 'balloonday', name: '热气球日', path: 'https://cn.bing.com/th?id=OHR.BalloonDay_ZH-CN7571792218_1920x1080.jpg' },
    { id: 'mtprevostduncan', name: '普里沃斯特山（邓肯）', path: 'https://cn.bing.com/th?id=OHR.MtPrevostDuncan_ZH-CN2333619635_1920x1080.jpg' },
    { id: 'deathvalleysalt', name: '死亡谷盐地', path: 'https://cn.bing.com/th?id=OHR.DeathValleySalt_ZH-CN8438207719_1920x1080.jpg' },
    { id: 'arroyogrande', name: '阿罗约格兰德', path: 'https://cn.bing.com/th?id=OHR.ArroyoGrande_ZH-CN2178202888_1920x1080.jpg' },
    { id: 'lakebledsnow', name: '布莱德湖雪景', path: 'https://cn.bing.com/th?id=OHR.LakeBledSnow_ZH-CN4118056813_1920x1080.jpg' },
    { id: 'misoolisland', name: '米苏尔岛', path: 'https://cn.bing.com/th?id=OHR.MisoolIsland_ZH-CN9038691748_1920x1080.jpg' }    
  ];
  
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      setTime(`${hours}:${minutes}`);
    };
    
    updateTime();
    const interval = setInterval(updateTime, 1000);
    
    return () => clearInterval(interval);
  }, []);
  
  // 从localStorage加载壁纸设置
  useEffect(() => {
    try {
      const savedWallpaper = localStorage.getItem('currentWallpaper');
      if (savedWallpaper) {
        setCurrentWallpaper(savedWallpaper);
        setSelectedWallpaper(savedWallpaper);
      }
    } catch (error) {
      console.error('加载壁纸设置时出错:', error);
    }
  }, []);
  
  // 自动聚焦功能
  useEffect(() => {
    // 检查URL哈希值是否包含autofocus
    if (window.location.hash === '#autofocus') {
      // 短暂延迟确保DOM已经渲染
      setTimeout(() => {
        if (searchInputRef.current) {
          searchInputRef.current.focus();
          setIsSearchFocused(true);
        }
      }, 100);
    }
  }, []);
  
  useEffect(() => {
    // 点击页面其他地方关闭设置菜单和登录窗口
    const handleClickOutside = (event) => {
      const settingsMenu = document.getElementById('settings-menu');
      const settingsButton = document.getElementById('settings-button');
      
      if (settingsMenu && settingsButton && 
          !settingsMenu.contains(event.target) && 
          !settingsButton.contains(event.target)) {
        setShowSettings(false);
      }

      // 点击应用网格外部区域关闭应用网格
      if (showAppGrid && appGridRef.current && !appGridRef.current.contains(event.target)) {
        const appButton = document.getElementById('app-button');
        if (!appButton || !appButton.contains(event.target)) {
          setShowAppGrid(false);
        }
      }
      
      // 点击登录窗口外部区域关闭登录窗口
      if (showLoginModal && loginModalRef.current && !loginModalRef.current.contains(event.target)) {
        const loginButton = document.getElementById('login-button');
        if (!loginButton || !loginButton.contains(event.target)) {
          setShowLoginModal(false);
        }
      }
      
      // 点击搜索引擎选择器外部区域关闭选择器
      if (showEngineSelector) {
        const engineSelector = document.querySelector('.engine-selector');
        const engineButton = document.querySelector('.engine-button');
        if ((!engineSelector || !engineSelector.contains(event.target)) && 
            (!engineButton || !engineButton.contains(event.target))) {
          setShowEngineSelector(false);
        }
      }
      
      // 点击任意位置关闭右键菜单
      if (contextMenu.show) {
        // 检查点击的元素是否在右键菜单内
        const contextMenuElement = document.querySelector('.context-menu');
        if (!contextMenuElement || !contextMenuElement.contains(event.target)) {
          closeContextMenu();
        }
      }
    };
    
    // 添加右键菜单事件
    const handleContextMenu = (event) => {
      event.preventDefault();
      setShowAppGrid(true);
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('contextmenu', handleContextMenu);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, [showAppGrid, showLoginModal, contextMenu.show, showEngineSelector]);
  
  const handleSearchFocus = () => {
    setIsSearchFocused(true);
  };
  
  const handleSearchBlur = (e) => {
    // 延迟一点时间，以便点击历史记录项时不会立即关闭
    setTimeout(() => {
      setIsSearchFocused(false);
    }, 100);
  };
  
  const handleSearchMouseEnter = () => {
    setIsSearchHovered(true);
  };
  
  const handleSearchMouseLeave = () => {
    setIsSearchHovered(false);
  };
  
  // 从localStorage加载搜索历史
  useEffect(() => {
    try {
      const savedHistory = localStorage.getItem('searchHistory');
      if (savedHistory) {
        const parsedHistory = JSON.parse(savedHistory);
        if (Array.isArray(parsedHistory) && parsedHistory.length > 0) {
          setSearchHistory(parsedHistory);
        }
      }
    } catch (error) {
      console.error('加载搜索历史时出错:', error);
    }
  }, []);
  
  // 当搜索历史变化时保存到localStorage
  useEffect(() => {
    try {
      localStorage.setItem('searchHistory', JSON.stringify(searchHistory));
    } catch (error) {
      console.error('保存搜索历史时出错:', error);
    }
  }, [searchHistory]);
  
  const clearHistory = () => {
    setSearchHistory([]);
    // 同时从localStorage中清除
    try {
      localStorage.removeItem('searchHistory');
    } catch (error) {
      console.error('清除搜索历史时出错:', error);
    }
  };
  
  const toggleEngineSelector = () => {
    setShowEngineSelector(!showEngineSelector);
  };
  
  const selectEngine = (engine) => {
    setCurrentEngine(engine);
    setShowEngineSelector(false);
    
    // 保存搜索引擎选择到localStorage
    try {
      localStorage.setItem('selectedSearchEngine', JSON.stringify(engine));
    } catch (error) {
      console.error('保存搜索引擎选择时出错:', error);
    }
    
    // 选择搜索引擎后，将焦点设置回搜索框
    if (searchInputRef.current) {
      setTimeout(() => {
        searchInputRef.current.focus();
      }, 10);
    }
  };
  
  // 从localStorage加载搜索引擎选择
  useEffect(() => {
    try {
      const savedEngine = localStorage.getItem('selectedSearchEngine');
      if (savedEngine) {
        const parsedEngine = JSON.parse(savedEngine);
        setCurrentEngine(parsedEngine);
      }
    } catch (error) {
      console.error('加载搜索引擎选择时出错:', error);
    }
  }, []);
  
  const toggleSettings = () => {
    setShowSettings(!showSettings);
  };
  
  const openWallpaperModal = () => {
    // 保存当前壁纸以便取消时恢复
    setSelectedWallpaper(currentWallpaper);
    setShowWallpaperModal(true);
  };
  
  const closeWallpaperModal = () => {
    // 如果用户没有应用，恢复到原来的壁纸
    setCurrentWallpaper(localStorage.getItem('currentWallpaper') || '/wallpaper/Default1.jpg');
    setShowWallpaperModal(false);
  };
  
  const openAboutModal = () => {
    setShowAboutModal(true);
  };
  
  const closeAboutModal = () => {
    setShowAboutModal(false);
  };
  
  const openExternalLink = (url) => {
    window.open(url, '_self');
  };
  
  const selectWallpaper = (wallpaperPath) => {
    setSelectedWallpaper(wallpaperPath);
    // 即时预览壁纸
    setCurrentWallpaper(wallpaperPath);
  };
  
  const applyWallpaper = () => {
    // 保存壁纸设置到localStorage
    try {
      localStorage.setItem('currentWallpaper', selectedWallpaper);
    } catch (error) {
      console.error('保存壁纸设置时出错:', error);
    }
    closeWallpaperModal();
  };
  
  const handleSearch = (searchTerm) => {
    if (searchTerm.trim()) {
      window.open(currentEngine.searchUrl + encodeURIComponent(searchTerm), '_self');
      // 添加到搜索历史
      if (!searchHistory.includes(searchTerm)) {
        setSearchHistory([searchTerm, ...searchHistory.filter(item => item !== '')].slice(0, 5));
      }
    }
  };
  
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch(e.target.value);
      e.target.value = '';
    }
  };
  
  // 底部应用图标数据
  const appIcons = [
    { name: '应用', icon: 'https://img.icons8.com/fluency/48/000000/apps-tab.png' },
    { name: '翻译', icon: 'https://img.icons8.com/color/48/000000/google-translate.png', url: 'https://fanyi.baidu.com/' },
    { name: '淘宝', icon: 'https://img.icons8.com/fluency/48/000000/shopping-mall.png', url: 'https://www.taobao.com/' },
    { name: 'AI 工具', icon: 'https://img.icons8.com/color/48/000000/chatgpt.png', url: 'https://chat.openai.com/' },
    { name: '图片', icon: 'https://img.icons8.com/color/48/000000/image.png', url: 'https://unsplash.com/' },
    { name: '便笺', icon: 'https://img.icons8.com/color/48/000000/note.png', url: 'https://keep.google.com/' },
    { name: '天气', icon: 'https://img.icons8.com/fluency/48/000000/partly-cloudy-day.png', url: 'https://tianqi.qq.com/' },
    { name: 'QQ 邮箱', icon: 'https://img.icons8.com/color/48/000000/gmail-new.png', url: 'https://mail.qq.com/' },
    { name: '云音乐', icon: 'https://img.icons8.com/color/48/000000/music.png', url: 'https://music.163.com/' },
    { name: 'bilibili', icon: 'https://img.icons8.com/color/48/000000/youtube-play.png', url: 'https://www.bilibili.com/' },
    { name: '壁纸', icon: 'https://img.icons8.com/fluency/48/000000/image.png', url: 'https://wallhaven.cc/' }
  ];
  
  // 应用网格数据
  const [appGridData, setAppGridData] = useState([
    { name: '翻译', icon: 'https://img.icons8.com/color/48/000000/google-translate.png', url: 'https://fanyi.baidu.com/' },
    { name: '淘宝', icon: 'https://img.icons8.com/fluency/48/000000/shopping-mall.png', url: 'https://www.taobao.com/' },
    { name: 'AI 工具', icon: 'https://img.icons8.com/color/48/000000/chatgpt.png', url: 'https://chat.openai.com/' },
    { name: '图片', icon: 'https://img.icons8.com/color/48/000000/image.png', url: 'https://unsplash.com/' },
    { name: '便笺', icon: 'https://img.icons8.com/color/48/000000/note.png', url: 'https://keep.google.com/' },
    { name: 'QQ 邮箱', icon: 'https://img.icons8.com/color/48/000000/gmail-new.png', url: 'https://mail.qq.com/' },
    { name: '云音乐', icon: 'https://img.icons8.com/color/48/000000/music.png', url: 'https://music.163.com/' },
    { name: 'bilibili', icon: 'https://img.icons8.com/color/48/000000/youtube-play.png', url: 'https://www.bilibili.com/' },
    { name: '壁纸', icon: 'https://img.icons8.com/fluency/48/000000/image.png', url: 'https://wallhaven.cc/' },
    { name: '天气', icon: 'https://img.icons8.com/fluency/48/000000/partly-cloudy-day.png', url: 'https://weather.com/' },
    { name: '添加', icon: 'https://img.icons8.com/ios/50/000000/plus.png' }
  ]);
  
  // 加载用户应用
  const loadUserApps = async () => {
    if (!isLoggedIn || !userData || !userData.id) return;
    
    try {
      // 获取不在收纳夹中的应用
      const apps = await fetchApps(userData.id);
      
      // 将API获取的应用与默认应用合并
      const defaultApps = appGridData.filter(app => app.name === '添加' || !apps.some(a => a.url === app.url));
      
      // 转换API应用格式
      const userApps = apps.map(app => ({
        id: app.id,
        name: app.name,
        icon: app.icon,
        url: app.url,
        folder_id: app.folder_id
      }));
      
      // 合并应用列表
      setAppGridData([...userApps, ...defaultApps]);
    } catch (error) {
      console.error('加载用户应用失败:', error);
    }
  };
  
  // 登录后加载用户数据
  useEffect(() => {
    if (isLoggedIn && userData) {
      loadUserApps();
    }
  }, [isLoggedIn, userData]);
  
  // 打开应用网格时加载最新数据
  useEffect(() => {
    if (showAppGrid && isLoggedIn && userData) {
      loadUserApps();
    }
  }, [showAppGrid]);
  
  const toggleAppGrid = () => {
    setShowAppGrid(!showAppGrid);
    // 如果打开应用网格，加载应用列表
    if (!showAppGrid && isLoggedIn && userData) {
      // 重置当前文件夹视图
      setCurrentFolderView(null);
    }
  };
  
  const handleAppClick = (appName, url, folderId) => {
    if (appName === '应用') {
      toggleAppGrid();
    } else if (appName === '壁纸') {
      openWallpaperModal();
    } else if (appName === '添加') {
      if (isLoggedIn) {
        setShowAddAppModal(true);
      } else {
        toggleLoginModal();
      }
    } else if (folderId) {
      // 如果是收纳夹，显示收纳夹内容
      openFolder(folderId);
    } else if (url) {
      window.open(url, '_self');
    }
  };
  
  const openFolder = async (folderId) => {
    if (!isLoggedIn || !userData) {
      return;
    }
    
    try {
      // 找到对应的收纳夹
      const folder = folders.find(f => f.id === folderId);
      if (!folder) return;
      
      // 获取收纳夹中的应用
      const apps = await fetchApps(userData.id, folderId);
      
      // 设置当前文件夹视图
      setCurrentFolderView({
        folder: folder,
        apps: apps
      });
    } catch (error) {
      console.error('打开收纳夹失败:', error);
    }
  };
  
  const closeFolder = () => {
    setCurrentFolderView(null);
  };
  
  const toggleFolderSelector = () => {
    setShowFolderSelector(!showFolderSelector);
  };
  
  const selectFolder = (folder) => {
    setSelectedFolder(folder);
    setNewAppData({...newAppData, folder_id: folder ? folder.id : null});
    setShowFolderSelector(false);
  };
  
  const handleAddApp = async (e) => {
    e.preventDefault();
    
    if (!isLoggedIn) {
      toggleLoginModal();
      return;
    }
    
    if (!newAppData.name || !newAppData.url) {
      return;
    }
    
    // 如果没有提供图标，尝试获取网站图标
    const icon = newAppData.icon || `https://api.xinac.net/icon/?url=${encodeURIComponent(newAppData.url)}`;
    
    const appData = {
      ...newAppData,
      icon: icon
    };
    
    const app = await createApp(appData);
    
    if (app) {
      setShowAddAppModal(false);
      // 重置表单
      setNewAppData({
        name: '',
        url: '',
        icon: '',
        folder_id: null
      });
      setSelectedFolder(null);
      
      // 如果在收纳夹视图中，刷新当前收纳夹
      if (currentFolderView && currentFolderView.folder.id === app.folder_id) {
        openFolder(app.folder_id);
      } else {
        // 刷新应用列表
        loadUserApps();
      }
    }
  };
  
  // 检查是否已登录
  useEffect(() => {
    try {
      const userSession = localStorage.getItem('userSession');
      if (userSession) {
        const userData = JSON.parse(userSession);
        setIsLoggedIn(true);
        setUserData(userData);
        
        // 如果已登录，获取收纳夹列表
        if (userData && userData.id) {
          fetchFolders(userData.id);
        }
      }
    } catch (error) {
      console.error('加载用户会话时出错:', error);
    }
  }, []);
  
  // 获取用户的收纳夹列表
  const fetchFolders = async (userId) => {
    try {
      const response = await fetch(`https://www.pp93.com/tab/api/folders.php?user_id=${userId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      const data = await response.json();
      
      if (data.success) {
        setFolders(data.folders || []);
      } else {
        console.error('获取收纳夹失败:', data.message);
      }
    } catch (error) {
      console.error('获取收纳夹请求出错:', error);
    }
  };
  
  // 获取应用列表（可以指定收纳夹ID）
  const fetchApps = async (userId, folderId = null) => {
    try {
      let url = `https://www.pp93.com/tab/api/custom_apps.php?user_id=${userId}`;
      if (folderId) {
        url += `&folder_id=${folderId}`;
      }
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      const data = await response.json();
      
      if (data.success) {
        return data.apps || [];
      } else {
        console.error('获取应用失败:', data.message);
        return [];
      }
    } catch (error) {
      console.error('获取应用请求出错:', error);
      return [];
    }
  };
  
  // 创建新收纳夹
  const createFolder = async (folderName) => {
    if (!isLoggedIn || !userData || !userData.id) {
      console.error('用户未登录');
      return null;
    }
    
    try {
      const response = await fetch('https://www.pp93.com/tab/api/folders.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          user_id: userData.id,
          name: folderName,
          icon: 'https://img.icons8.com/color/48/000000/folder-invoices.png'
        }),
      });
      
      const data = await response.json();
      
      if (data.success) {
        // 更新收纳夹列表
        fetchFolders(userData.id);
        return data.folder;
      } else {
        console.error('创建收纳夹失败:', data.message);
        return null;
      }
    } catch (error) {
      console.error('创建收纳夹请求出错:', error);
      return null;
    }
  };
  
  // 创建新应用
  const createApp = async (appData) => {
    if (!isLoggedIn || !userData || !userData.id) {
      console.error('用户未登录');
      return null;
    }
    
    try {
      const response = await fetch('https://www.pp93.com/tab/api/custom_apps.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          user_id: userData.id,
          ...appData
        }),
      });
      
      const data = await response.json();
      
      if (data.success) {
        return data.app;
      } else {
        console.error('创建应用失败:', data.message);
        return null;
      }
    } catch (error) {
      console.error('创建应用请求出错:', error);
      return null;
    }
  };
  
  const toggleLoginModal = () => {
    setShowLoginModal(!showLoginModal);
    // 重置表单
    if (!showLoginModal) {
      setEmail('');
      setPassword('');
      setLoginError('');
    }
  };
  
  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setLoginError('');
    
    try {
      // 发送登录请求到后端
      const response = await fetch('https://www.pp93.com/tab/api/login.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });
      
      const data = await response.json();
      
      if (data.success) {
        // 登录成功
        setIsLoggedIn(true);
        setUserData(data.user);
        // 保存会话到本地存储
        localStorage.setItem('userSession', JSON.stringify(data.user));
        setShowLoginModal(false);
        
        // 获取用户数据
        fetchFolders(data.user.id);
        loadUserApps();
      } else {
        // 登录失败
        setLoginError(data.message || '登录失败，请检查您的邮箱和密码');
      }
    } catch (error) {
      console.error('登录请求出错:', error);
      setLoginError('网络错误，请稍后再试');
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserData(null);
    localStorage.removeItem('userSession');
  };
  
  // 自定义滚动条样式
  const scrollbarStyles = `
    .app-grid-container::-webkit-scrollbar {
      width: 0px;
      display: none;
    }
    
    .app-grid-container {
      -ms-overflow-style: none;  /* IE and Edge */
      scrollbar-width: none;  /* Firefox */
    }
  `;
  
  // 处理右键菜单显示
  const handleItemContextMenu = (e, type, item) => {
    e.preventDefault();
    e.stopPropagation();
    
    // 只有登录用户才能使用右键菜单
    if (!isLoggedIn || !userData) return;
    
    // 阻止冒泡，防止触发父元素的点击事件
    e.nativeEvent.stopImmediatePropagation();
    
    setContextMenu({
      show: true,
      x: e.clientX,
      y: e.clientY,
      type,
      item
    });
  };
  
  // 关闭右键菜单
  const closeContextMenu = () => {
    setContextMenu({
      show: false,
      x: 0,
      y: 0,
      type: '',
      item: null
    });
  };
  
  // 编辑项目
  const handleEditItem = () => {
    const { type, item } = contextMenu;
    
    // 设置编辑数据
    setEditData({
      type,
      item: { ...item }
    });
    
    // 显示编辑模态框
    setShowEditModal(true);
    
    // 关闭右键菜单
    closeContextMenu();
  };
  
  // 删除项目
  const handleDeleteItem = async () => {
    const { type, item } = contextMenu;
    
    if (!isLoggedIn || !userData) return;
    
    try {
      if (type === 'folder') {
        // 删除收纳夹
        const response = await fetch('https://www.pp93.com/tab/api/folders.php', {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            user_id: userData.id,
            folder_id: item.id
          })
        });
        
        const data = await response.json();
        
        if (data.success) {
          // 更新收纳夹列表
          fetchFolders(userData.id);
          
          // 如果当前在该收纳夹视图中，返回主视图
          if (currentFolderView && currentFolderView.folder.id === item.id) {
            setCurrentFolderView(null);
          }
        } else {
          console.error('删除收纳夹失败:', data.message);
        }
      } else if (type === 'app') {
        // 删除应用
        const response = await fetch('https://www.pp93.com/tab/api/custom_apps.php', {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            user_id: userData.id,
            app_id: item.id
          })
        });
        
        const data = await response.json();
        
        if (data.success) {
          // 如果在收纳夹视图中，刷新当前收纳夹
          if (currentFolderView && item.folder_id === currentFolderView.folder.id) {
            openFolder(currentFolderView.folder.id);
          } else {
            // 否则刷新应用列表
            loadUserApps();
          }
        } else {
          console.error('删除应用失败:', data.message);
        }
      }
    } catch (error) {
      console.error('删除请求出错:', error);
    }
    
    // 关闭右键菜单
    closeContextMenu();
  };
  
  // 保存编辑
  const handleSaveEdit = async () => {
    if (!editData || !isLoggedIn || !userData) return;
    
    const { type, item } = editData;
    
    try {
      if (type === 'folder') {
        // 更新收纳夹
        const response = await fetch('https://www.pp93.com/tab/api/folders.php', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            user_id: userData.id,
            folder_id: item.id,
            name: item.name,
            icon: item.icon
          })
        });
        
        const data = await response.json();
        
        if (data.success) {
          // 更新收纳夹列表
          fetchFolders(userData.id);
          
          // 如果当前在该收纳夹视图中，更新视图
          if (currentFolderView && currentFolderView.folder.id === item.id) {
            setCurrentFolderView({
              ...currentFolderView,
              folder: data.folder
            });
          }
        } else {
          console.error('更新收纳夹失败:', data.message);
        }
      } else if (type === 'app') {
        // 更新应用
        const response = await fetch('https://www.pp93.com/tab/api/custom_apps.php', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            user_id: userData.id,
            app_id: item.id,
            name: item.name,
            icon: item.icon,
            url: item.url,
            folder_id: item.folder_id
          })
        });
        
        const data = await response.json();
        
        if (data.success) {
          // 如果在收纳夹视图中，刷新当前收纳夹
          if (currentFolderView && item.folder_id === currentFolderView.folder.id) {
            openFolder(currentFolderView.folder.id);
          } else {
            // 否则刷新应用列表
            loadUserApps();
          }
        } else {
          console.error('更新应用失败:', data.message);
        }
      }
    } catch (error) {
      console.error('更新请求出错:', error);
    }
    
    // 关闭编辑模态框
    setShowEditModal(false);
    setEditData(null);
  };
  
  return (
    <div className="relative h-screen w-full bg-cover bg-center" 
         style={{ backgroundImage: `url("${currentWallpaper}")` }}>
      <style dangerouslySetInnerHTML={{ __html: scrollbarStyles }} />
      <div className={`absolute inset-0 ${
        isSearchFocused 
          ? 'backdrop-blur-md bg-black bg-opacity-30' 
          : showAppGrid 
            ? 'backdrop-blur-md bg-black bg-opacity-40' 
            : 'bg-black bg-opacity-10'
      } transition-all duration-300`}
      onClick={(e) => {
        // 如果显示应用网格并且点击的是背景区域，则隐藏应用网格
        if (showAppGrid && e.target === e.currentTarget) {
          setShowAppGrid(false);
        }
      }}
      >
        {/* 右上角按钮 */}
        <div className="absolute top-4 right-4 flex items-center space-x-4">
          {!isLoggedIn && (
            <button 
              id="login-button"
              className="w-9 h-9 rounded-full bg-white bg-opacity-30 flex items-center justify-center hover:bg-opacity-40 transition-all"
              onClick={toggleLoginModal}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </button>
          )}
          
          <button 
            id="settings-button"
            className="w-9 h-9 rounded-full bg-white bg-opacity-30 flex items-center justify-center hover:bg-opacity-40 transition-all"
            onClick={toggleSettings}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </button>
          
          {/* 设置菜单 */}
          {showSettings && (
            <div 
              id="settings-menu"
              className="absolute top-14 right-0 w-60 bg-white rounded-xl shadow-lg overflow-hidden z-50"
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.95)' }}
            >
              {isLoggedIn && (
                <div className="px-5 py-3 border-b border-gray-200">
                  <div className="flex items-center">
                    <div className="w-8 h-8 rounded-full bg-green-500 flex items-center justify-center text-white font-bold mr-3">
                      {userData && userData.email ? userData.email.charAt(0).toUpperCase() : 'U'}
                    </div>
                    <div className="flex-1 truncate">
                      <div className="text-sm font-medium text-gray-700 truncate">{userData?.email}</div>
                      <div className="text-xs text-gray-500">已登录</div>
                    </div>
                  </div>
                  <button 
                    onClick={handleLogout}
                    className="mt-2 w-full px-3 py-1.5 text-sm text-white bg-red-500 rounded hover:bg-red-600 transition-colors"
                  >
                    退出登录
                  </button>
                </div>
              )}
              
              {settingsOptions.map((option, index) => (
                <React.Fragment key={index}>
                  <div 
                    className="flex items-center px-5 py-3.5 hover:bg-gray-100 cursor-pointer"
                    onClick={() => {
                      if (option.text === '壁纸设置') {
                        openWallpaperModal();
                        setShowSettings(false);
                      } else if (option.text === '支持我们') {
                        openExternalLink('https://www.pp93.com/donate/');
                        setShowSettings(false);
                      } else if (option.text === '浏览器插件') {
                        openExternalLink('https://windtab.pp93.com/');
                        setShowSettings(false);
                      } else if (option.text === '关于我们') {
                        openAboutModal();
                        setShowSettings(false);
                      } 
                    }}
                  >
                    <div className="text-gray-500 mr-3.5">
                      {option.icon}
                    </div>
                    <span className="text-gray-700 text-sm">{option.text}</span>
                  </div>
                  {index === 5 && <div className="border-t border-gray-200"></div>}
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
        
        {/* 登录模态框 */}
        {showLoginModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div 
              ref={loginModalRef}
              className="bg-white rounded-lg shadow-xl w-full max-w-md overflow-hidden"
            >
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
                <h2 className="text-xl font-bold">账号登录</h2>
                <button 
                  onClick={() => setShowLoginModal(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              
              <form onSubmit={handleLogin} className="p-6">
                <div className="mb-4">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                    电子邮箱
                  </label>
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="请输入您的电子邮箱"
                    required
                  />
                </div>
                
                <div className="mb-4">
                  <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                    密码
                  </label>
                  <input
                    id="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="请输入您的密码"
                    required
                  />
                </div>
                
                {loginError && (
                  <div className="mb-4 p-2 bg-red-100 border border-red-300 text-red-700 rounded">
                    {loginError}
                  </div>
                )}
                
                <div className="text-sm text-gray-600 mb-4">
                  如果账号不存在，系统将自动为您注册新账号
                </div>
                
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${isLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
                >
                  {isLoading ? '处理中...' : '登录 / 注册'}
                </button>
              </form>
            </div>
          </div>
        )}
        
        {/* 时间显示和搜索框/应用网格 */}
        <div className="flex flex-col items-center justify-center h-full -mt-16">
          {/* 时间只在不显示应用网格时显示 */}
          {!showAppGrid && <h1 className="text-6xl font-bold text-white mb-12">{time}</h1>}
          
          {/* 搜索框或应用网格 */}
          {!showAppGrid ? (
            <div className="w-full max-w-xl px-4 relative">
              <div 
                className={`${
                  isSearchFocused 
                    ? 'bg-white bg-opacity-90 shadow-lg' 
                    : isSearchHovered 
                      ? 'bg-white bg-opacity-30' 
                      : 'bg-white bg-opacity-20'
                } backdrop-blur-sm rounded-full px-6 py-2 flex items-center transition-colors transition-opacity duration-300 ease-in-out`}
                onMouseEnter={handleSearchMouseEnter}
                onMouseLeave={handleSearchMouseLeave}
              >
                {/* 搜索引擎图标 - 仅在聚焦时显示 */}
                {isSearchFocused && (
                  <div 
                    className="mr-2 w-8 h-8 flex-shrink-0 cursor-pointer text-gray-500 engine-button flex items-center justify-center rounded-full hover:bg-white hover:bg-opacity-40 transition-all duration-200"
                    onClick={toggleEngineSelector}
                    title="选择搜索引擎"
                  >
                    <img src={currentEngine.icon} alt={currentEngine.name} className="w-5 h-5" />
                  </div>
                )}
                
                <input
                  ref={searchInputRef}
                  type="text"
                  placeholder="搜索"
                  className={`w-full bg-transparent border-none outline-none ${isSearchFocused ? 'text-gray-800 placeholder-gray-500' : 'text-white placeholder-white'} text-lg text-center`}
                  onFocus={handleSearchFocus}
                  onBlur={handleSearchBlur}
                  onKeyPress={handleKeyPress}
                />
                
                {/* 搜索图标 - 仅在聚焦时显示 */}
                {isSearchFocused ? (
                  <div 
                    className="ml-2 text-lime-500 cursor-pointer w-8 h-8 rounded-full hover:bg-white hover:bg-opacity-40 transition-all duration-200 flex items-center justify-center"
                    onClick={() => document.querySelector('input').value && handleSearch(document.querySelector('input').value)}
                    title="搜索"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clipRule="evenodd" />
                    </svg>
                  </div>
                ) : (
                  <div className="ml-2 text-white cursor-pointer w-8 h-8 rounded-full hover:bg-white hover:bg-opacity-30 transition-all duration-200 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clipRule="evenodd" />
                    </svg>
                  </div>
                )}
              </div>
              
              {/* 搜索引擎选择器 */}
              {showEngineSelector && (
                <div className="absolute left-0 top-14 bg-white rounded-lg shadow-lg w-64 z-50 overflow-hidden engine-selector">
                  <div className="p-2">
                    <h3 className="text-gray-500 text-xs px-2 mb-1">选择搜索引擎</h3>
                    {searchEngines.map((engine, index) => (
                      <div 
                        key={index} 
                        className={`flex items-center py-2 px-3 hover:bg-gray-100 cursor-pointer rounded ${currentEngine.name === engine.name ? 'bg-gray-100' : ''}`}
                        onClick={() => selectEngine(engine)}
                      >
                        <img 
                          src={engine.icon} 
                          alt={engine.name} 
                          className="w-5 h-5 mr-3"
                        />
                        <span className="text-gray-700">{engine.name}</span>
                        {currentEngine.name === engine.name && (
                          <svg className="ml-auto w-4 h-4 text-green-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                          </svg>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              
              {/* 历史记录和搜索建议 */}
              {isSearchFocused && searchHistory.length > 0 && searchHistory[0] !== '' && (
                <div className="mt-2 bg-white bg-opacity-20 backdrop-blur-md rounded-xl overflow-hidden shadow-lg">
                  <div className="p-2">
                    {searchHistory.map((item, index) => (
                      <div 
                        key={index} 
                        className="flex items-center py-1.5 text-white hover:bg-white hover:bg-opacity-10 cursor-pointer px-3 rounded transition-all duration-200"
                        onClick={() => {
                          document.querySelector('input').value = item;
                          handleSearch(item);
                        }}
                      >
                        <span className="font-medium text-sm">{item}</span>
                      </div>
                    ))}
                  </div>
                  <div className="py-1.5 px-3 flex items-center border-t border-gray-600 border-opacity-30">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 text-white opacity-70 mr-1" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M8.75 1A2.75 2.75 0 006 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 10.23 1.482l.149-.022.841 10.518A2.75 2.75 0 007.596 19h4.807a2.75 2.75 0 002.742-2.53l.841-10.52.149.023a.75.75 0 00.23-1.482A41.03 41.03 0 0014 4.193V3.75A2.75 2.75 0 0011.25 1h-2.5zM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4zM8.58 7.72a.75.75 0 00-1.5.06l.3 7.5a.75.75 0 101.5-.06l-.3-7.5zm4.34.06a.75.75 0 10-1.5-.06l-.3 7.5a.75.75 0 101.5.06l.3-7.5z" clipRule="evenodd" />
                    </svg>
                    <button 
                      onClick={clearHistory}
                      className="text-white opacity-70 hover:opacity-100 text-xs"
                    >
                      清除历史记录
                    </button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div 
              ref={appGridRef} 
              className="w-full max-w-4xl px-4 overflow-y-auto app-grid-container"
              style={{ 
                maxHeight: 'calc(100vh - 180px)',
                paddingBottom: '80px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
              }}
              onClick={(e) => {
                // 阻止事件冒泡，防止点击网格内部关闭网格
                e.stopPropagation();
              }}
            >
              {/* 如果在收纳夹视图中，显示返回按钮和收纳夹标题 */}
              {currentFolderView ? (
                <div className="mb-6 overflow-y-auto" style={{ maxHeight: 'calc(100vh - 250px)' }}>
                  <div className="flex items-center mb-4">
                    <button 
                      onClick={closeFolder}
                      className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center mr-3 hover:bg-opacity-30"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                      </svg>
                    </button>
                    <h2 className="text-2xl font-bold text-white">{currentFolderView.folder.name}</h2>
                  </div>
                  
                  {/* 收纳夹中的应用 */}
                  <div className="grid grid-cols-5 gap-6">
                    {currentFolderView.apps.map((app) => (
                      <div 
                        key={app.id}
                        className="flex flex-col items-center"
                        onClick={(e) => {
                          e.stopPropagation();
                          window.open(app.url, '_self');
                        }}
                        onContextMenu={(e) => {
                          handleItemContextMenu(e, 'app', app);
                        }}
                      >
                        <div className="w-20 h-20 bg-white rounded-2xl flex items-center justify-center mb-3 shadow-lg hover:shadow-xl transition-all cursor-pointer">
                          <img 
                            src={app.icon} 
                            alt={app.name} 
                            className="w-10 h-10"
                          />
                        </div>
                        <span className="text-white text-sm">{app.name}</span>
                      </div>
                    ))}
                    
                    {/* 添加按钮 */}
                    {isLoggedIn && (
                      <div 
                        className="flex flex-col items-center"
                        onClick={() => {
                          setSelectedFolder(currentFolderView.folder);
                          setNewAppData({...newAppData, folder_id: currentFolderView.folder.id});
                          setShowAddAppModal(true);
                        }}
                      >
                        <div className="w-20 h-20 bg-white bg-opacity-20 rounded-2xl flex items-center justify-center mb-3 shadow-lg hover:shadow-xl transition-all cursor-pointer">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-white opacity-70" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                          </svg>
                        </div>
                        <span className="text-white text-sm">添加</span>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div>
                  {/* 用户收纳夹 */}
                  {isLoggedIn && folders.length > 0 && (
                    <div className="mb-8">
                      <h2 className="text-xl font-bold text-white mb-4">收纳夹</h2>
                      <div className="grid grid-cols-5 gap-6">
                        {folders.map((folder) => (
                          <div 
                            key={folder.id}
                            className="flex flex-col items-center"
                            onClick={() => openFolder(folder.id)}
                            onContextMenu={(e) => handleItemContextMenu(e, 'folder', folder)}
                          >
                            <div className="w-20 h-20 bg-white rounded-2xl flex items-center justify-center mb-3 shadow-lg hover:shadow-xl transition-all cursor-pointer">
                              <img 
                                src={folder.icon || "https://img.icons8.com/color/48/000000/folder-invoices.png"} 
                                alt={folder.name} 
                                className="w-10 h-10"
                              />
                            </div>
                            <span className="text-white text-sm">{folder.name}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  
                  {/* 应用网格 */}
                  <div className="grid grid-cols-5 gap-6 mb-8">
                    {isLoggedIn ? (
                      <>
                        {/* 从API获取的应用 */}
                        {/* 默认应用图标 */}
                        {appGridData.map((app, index) => (
                          <div 
                            key={index}
                            className="flex flex-col items-center"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleAppClick(app.name, app.url);
                            }}
                            onContextMenu={(e) => {
                              // 只有自定义应用才能编辑和删除
                              if (app.id && isLoggedIn) {
                                handleItemContextMenu(e, 'app', app);
                              }
                            }}
                          >
                            <div className={`w-20 h-20 bg-white rounded-2xl flex items-center justify-center mb-3 shadow-lg hover:shadow-xl transition-all cursor-pointer`}>
                              <img 
                                src={app.icon} 
                                alt={app.name} 
                                className={`w-10 h-10 ${app.name === '添加' ? 'opacity-50' : ''}`}
                              />
                            </div>
                            <span className="text-white text-sm">{app.name}</span>
                          </div>
                        ))}
                      </>
                    ) : (
                      // 未登录时显示默认应用和添加按钮
                      <>
                        {appGridData.map((app, index) => (
                          <div 
                            key={index}
                            className="flex flex-col items-center"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleAppClick(app.name, app.url);
                            }}
                          >
                            <div className={`w-20 h-20 bg-white rounded-2xl flex items-center justify-center mb-3 shadow-lg hover:shadow-xl transition-all cursor-pointer`}>
                              <img 
                                src={app.icon} 
                                alt={app.name} 
                                className={`w-10 h-10 ${app.name === '添加' ? 'opacity-50' : ''}`}
                              />
                            </div>
                            <span className="text-white text-sm">{app.name}</span>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        
        {/* 底部应用图标栏 */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
          <div className="flex space-x-1 bg-white bg-opacity-20 backdrop-blur-sm rounded-2xl p-2">
            {/* 应用图标 */}
            {appIcons.slice(0, 11).map((app, i) => (
              <div 
                key={i}
                id={app.name === '应用' ? 'app-button' : ''}
                className="w-10 h-10 rounded-xl bg-white bg-opacity-90 flex items-center justify-center hover:bg-opacity-100 cursor-pointer transition-all"
                onClick={(e) => {
                  e.stopPropagation();
                  handleAppClick(app.name, app.url, selectedFolder ? selectedFolder.id : null);
                }}
              >
                <img src={app.icon} alt={app.name} className="w-6 h-6" />
              </div>
            ))}
          </div>
        </div>
        
        {/* 壁纸选择模态框 */}
        {showWallpaperModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-hidden">
              {/* 模态框标题栏 */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
                <h2 className="text-xl font-bold">壁纸偏好</h2>
                <button 
                  onClick={closeWallpaperModal}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              
              {/* 模态框内容 */}
              <div className="p-6 overflow-y-auto" style={{ maxHeight: 'calc(90vh - 120px)' }}>
               {/* <div className="mb-6">
                  <h3 className="text-lg font-semibold mb-3">自定义</h3>
                  <p className="text-gray-600 mb-4">将您喜爱的图片或视频设为壁纸。</p>
                  <p className="text-gray-600 mb-4">支持选择多张本地图片，起始页每次加载时随机显示一张。</p>
                  
                  <div className="flex space-x-3 mt-3">
                    <button className="flex items-center px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-gray-700">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      本地图片 / 视频
                    </button>
                    
                    <button className="flex items-center px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-gray-700">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                      </svg>
                      在线图片链接
                    </button>
                    
                    <button className="flex items-center px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-gray-700">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                      </svg>
                      AI 作图
                    </button>
                  </div>
                </div>*/}
                
                <div className="mt-8">
                  <h3 className="text-lg font-semibold mb-4">默认</h3>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
                    {wallpapers.map((wallpaper) => (
                      <div 
                        key={wallpaper.id}
                        className={`relative rounded-lg overflow-hidden cursor-pointer transition-all hover:opacity-90 ${selectedWallpaper === wallpaper.path ? 'ring-2 ring-blue-500' : ''}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          selectWallpaper(wallpaper.path);
                        }}
                      >
                        <img 
                          src={wallpaper.path} 
                          alt={wallpaper.name}
                          className="w-full h-24 object-cover"
                        />
                        {selectedWallpaper === wallpaper.path && (
                          <div className="absolute inset-0 bg-blue-500 bg-opacity-30 flex items-center justify-center">
                            <div className="bg-white rounded-full p-1">
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                              </svg>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              
              {/* 模态框底部按钮 */}
              <div className="px-6 py-4 bg-gray-50 flex justify-end">
                <button 
                  onClick={closeWallpaperModal}
                  className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 mr-2 hover:bg-gray-100"
                >
                  取消
                </button>
                <button 
                  onClick={applyWallpaper}
                  className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                >
                  应用
                </button>
              </div>
            </div>
          </div>
        )}
        
        {/* 添加应用模态框 */}
        {showAddAppModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div 
              ref={addAppModalRef}
              className="bg-white rounded-lg shadow-xl w-full max-w-md overflow-hidden"
            >
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
                <h2 className="text-xl font-bold">添加网站捷径</h2>
                <button 
                  onClick={() => setShowAddAppModal(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              
              <form onSubmit={handleAddApp} className="p-6">
                <div className="mb-4">
                  <label className="flex items-center mb-1">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                    </svg>
                    <span className="text-sm font-medium text-gray-700">网址</span>
                  </label>
                  <input
                    type="url"
                    value={newAppData.url}
                    onChange={(e) => setNewAppData({...newAppData, url: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="https://example.com"
                    required
                  />
                </div>
                
                <div className="mb-4">
                  <label className="flex items-center mb-1">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span className="text-sm font-medium text-gray-700">标题 - 留空即自动获取</span>
                  </label>
                  <input
                    type="text"
                    value={newAppData.name}
                    onChange={(e) => setNewAppData({...newAppData, name: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="网站名称"
                  />
                </div>
                
                <div className="mb-4">
                  <label className="flex items-center mb-1">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <span className="text-sm font-medium text-gray-700">图标</span>
                  </label>
                  <div className="flex">
                    <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center mr-3">
                      {newAppData.icon ? (
                        <img src={newAppData.icon} alt="图标预览" className="w-6 h-6" />
                      ) : (
                        <span className="text-gray-400 text-xs">自动</span>
                      )}
                    </div>
                    <input
                      type="text"
                      value={newAppData.icon}
                      onChange={(e) => setNewAppData({...newAppData, icon: e.target.value})}
                      className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="自动获取"
                    />
                  </div>
                </div>
                
                <div className="mb-4">
                  <label className="flex items-center mb-1">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
                    </svg>
                    <span className="text-sm font-medium text-gray-700">收纳夹</span>
                  </label>
                  <div 
                    className="relative w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm cursor-pointer"
                    onClick={toggleFolderSelector}
                  >
                    <div className="flex items-center justify-between">
                      <span className="text-gray-700">
                        {selectedFolder ? selectedFolder.name : '无'}
                      </span>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </div>
                    
                    {/* 收纳夹选择器 */}
                    {showFolderSelector && (
                      <div 
                        ref={folderSelectorRef}
                        className="absolute left-0 top-full mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg z-10"
                      >
                        <div className="max-h-48 overflow-y-auto">
                          <div 
                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center"
                            onClick={(e) => {
                              e.stopPropagation();
                              selectFolder(null);
                            }}
                          >
                            <span className="flex-grow">无</span>
                            {!selectedFolder && (
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                              </svg>
                            )}
                          </div>
                          
                          {folders.map(folder => (
                            <div 
                              key={folder.id}
                              className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center"
                              onClick={(e) => {
                                e.stopPropagation();
                                selectFolder(folder);
                              }}
                            >
                              <span className="flex-grow">{folder.name}</span>
                              {selectedFolder && selectedFolder.id === folder.id && (
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                              )}
                            </div>
                          ))}
                          
                          <div className="border-t border-gray-200 mt-1">
                            <div 
                              className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center text-blue-600"
                              onClick={(e) => {
                                e.stopPropagation();
                                const folderName = prompt("请输入收纳夹名称");
                                if (folderName && folderName.trim()) {
                                  createFolder(folderName.trim()).then(newFolder => {
                                    if (newFolder) {
                                      selectFolder(newFolder);
                                    }
                                  });
                                }
                              }}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                              </svg>
                              <span>创建收纳夹</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                
                <button
                  type="submit"
                  className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  添加
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
      
      {/* 右键菜单 */}
      {contextMenu.show && (
        <div 
          className="fixed bg-white rounded-lg shadow-lg py-1 z-50 w-40 context-menu"
          style={{ 
            top: `${contextMenu.y}px`, 
            left: `${contextMenu.x}px`,
            transform: 'translate(-50%, 10px)'
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div 
            className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center"
            onClick={(e) => {
              e.stopPropagation();
              handleEditItem();
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            <span>编辑</span>
          </div>
          <div 
            className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center text-red-600"
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteItem();
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
            <span>删除</span>
          </div>
        </div>
      )}
      
      {/* 编辑模态框 */}
      {showEditModal && editData && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={(e) => {
            // 点击背景关闭模态框
            if (e.target === e.currentTarget) {
              setShowEditModal(false);
            }
          }}
        >
          <div 
            className="bg-white rounded-lg shadow-xl w-full max-w-md overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
              <h2 className="text-xl font-bold">
                {editData.type === 'folder' ? '编辑收纳夹' : '编辑应用'}
              </h2>
              <button 
                onClick={() => setShowEditModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <div className="p-6">
              {/* 编辑表单 */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  名称
                </label>
                <input
                  type="text"
                  value={editData.item.name}
                  onChange={(e) => setEditData({
                    ...editData,
                    item: { ...editData.item, name: e.target.value }
                  })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder={editData.type === 'folder' ? "收纳夹名称" : "应用名称"}
                  required
                />
              </div>
              
              {editData.type === 'app' && (
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    网址
                  </label>
                  <input
                    type="url"
                    value={editData.item.url}
                    onChange={(e) => setEditData({
                      ...editData,
                      item: { ...editData.item, url: e.target.value }
                    })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="https://example.com"
                    required
                  />
                </div>
              )}
              
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  图标
                </label>
                <div className="flex">
                  <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center mr-3">
                    <img src={editData.item.icon} alt="图标预览" className="w-6 h-6" />
                  </div>
                  <input
                    type="text"
                    value={editData.item.icon}
                    onChange={(e) => setEditData({
                      ...editData,
                      item: { ...editData.item, icon: e.target.value }
                    })}
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="图标URL"
                    required
                  />
                </div>
              </div>
              
              {editData.type === 'app' && (
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    收纳夹
                  </label>
                  <select
                    value={editData.item.folder_id || ''}
                    onChange={(e) => setEditData({
                      ...editData,
                      item: { 
                        ...editData.item, 
                        folder_id: e.target.value ? parseInt(e.target.value) : null 
                      }
                    })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">无</option>
                    {folders.map(folder => (
                      <option key={folder.id} value={folder.id}>
                        {folder.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>
            
            <div className="px-6 py-4 bg-gray-50 flex justify-end">
              <button 
                onClick={() => setShowEditModal(false)}
                className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 mr-2 hover:bg-gray-100"
              >
                取消
              </button>
              <button 
                onClick={handleSaveEdit}
                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
              >
                保存
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* 关于我们模态框 */}
      {showAboutModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md overflow-hidden">
            {/* 模态框标题栏 */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
              <h2 className="text-xl font-bold">关于我们</h2>
              <button 
                onClick={closeAboutModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            {/* 模态框内容 */}
            <div className="p-6">
              <div className="flex items-center justify-center mb-4">
                <img src="/images/icon128.png" alt="清风新标签页" className="w-16 h-16 mr-3" />
                <h3 className="text-2xl font-bold text-gray-800">清风新标签页</h3>
              </div>
              
              <p className="text-gray-600 mb-4">
                清风新标签页是一款清爽简洁无广告的浏览器新标签页扩展。
              </p>
              
              <p className="text-gray-600 mb-4">
                我们致力于为用户提供最简洁、最高效的浏览体验，让您的每一次浏览都充满愉悦。
              </p>
              
              <p className="text-gray-600 mb-4">
                特点：
              </p>
              
              <ul className="list-disc pl-5 mb-4 text-gray-600">
                <li>简洁美观的界面设计</li>
                <li>完全无广告</li>
                <li>高度可定制化</li>
                <li>快速访问您喜爱的网站</li>
                <li>精美壁纸</li>
              </ul>
              
              <p className="text-gray-600">
                版本：1.1.0
              </p>
            </div>
            
            {/* 模态框底部按钮 */}
            <div className="px-6 py-4 bg-gray-50 flex justify-end">
              <button 
                onClick={closeAboutModal}
                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
              >
                关闭
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App; 